import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, checked } = useAuth();
  const loc = useLocation();
  if (!checked) {
    return (
      <div
        style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--ifl-bg)", color: "var(--ifl-muted)", fontFamily: "DM Sans, sans-serif" }}
        data-testid="auth-checking"
      >
        verificando sessão…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  return children;
}
